module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.name)
    }
  }), _c('span', [_vm._v(" -")]), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.business)
    }
  }), _c('br'), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.email)
    }
  }), (_vm.item.telephone) ? [_c('br'), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.telephone)
    }
  })] : _vm._e(), (_vm.item.cellphone) ? [_c('br'), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.cellphone)
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-51f2750a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/autocomplete/contact_item.vue
// module id = 1114
// module chunks = 1